import { Box, FormLabel, IconButton } from "@mui/material";
import React from "react";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import ImageNotSupportedOutlinedIcon from '@mui/icons-material/ImageNotSupportedOutlined';

const PublishResultsNoImage = ({ tagName, boxWidth, boxHeight, className = "" }) => {
    return (
        <Box
            sx={{
                backgroundColor: "#c7dbe540",
                width: "fit-content",
                height: "auto",
                padding: "1rem",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto",
                textAlign: "center",
            }}
            className={`publish_results_no_image ${className}`}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: boxWidth,
                    height: boxHeight,
                }}
            >
                <IconButton className="ty_pr_noImage">
                    <ImageNotSupportedOutlinedIcon />
                </IconButton>
                {/* <FormLabel className="ty-uppercase-label" sx={{textAlign: "center"}}>No {tagName} uploaded</FormLabel> */}
            </Box>
        </Box>
    );
};

export default PublishResultsNoImage;